export default "__VITE_ASSET__31e469de__"